(function dynamicPasswordDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlPassword', [])
        .directive('dynamicPassword', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-password/custom-control-password-template.html'
            };
        });

    angular.module('CustomControlPassword')
       .directive('dynamicFilterPassword', ['$translate', function () {
           return {
               templateUrl: '/app/directives/custom-control-password/custom-control-filter-password-template.html',
               replace: true,
               restrict: 'E',
               controller: [
                   '$scope', function($scope) {
                       if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                           $scope.data.metadataSearchTypeFrom = 'EqualIgnoreCase';
                       }
                   }
               ]
           };
       }]);
})();